import cn from 'classnames';
import { ButtonHTMLAttributes, forwardRef } from 'react';
import styles from './CustomButton.module.css';

export enum ButtonType {
  DEFAULT = 'typeDefault',
  LIGHT = 'typeLightColor',
  NOSTYLE = 'typeNoStyle',
  ACTIVENOSTYLE= 'typeActiveNoStyle',
  IMAGE = 'typeImage',
  GREEN = 'typeGreen',
  LIGHTBLUE = 'typeLightBlue',
  WHITE= 'typeWhite',
  RED= 'typeRed',
}

export enum ButtonSize {
  SMALL = 'sizeSmall',
  NORMAL = 'sizeNormal',
  MEDIUM = 'sizeMedium',
  LARGE = 'sizeLarge',
}

export enum ButtonFont {
  LIGHT = 'sizeLight',
  NORMAL = 'sizeRegular',
  BOLDMED = 'sizeBoldMed',
  SEMIBOLD = 'sizeSemiBold',
  BOLD = 'sizeBold',
}

export enum ButtonRadiusSize {
  OFF = 'radiusOff',
  SMALL = 'radiusSmall',
  NORMAL = 'radiusNormal',
  MEDIUM = 'radiusMedium',
  LARGE = 'radiusLarge',
}

export enum ButtonStatus {
  ON = '',
  OFF = 'off'
}

export interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  btnType?: ButtonType;
  btnSize?: ButtonSize;
  btnFont?: ButtonFont;
  btnStatus?: ButtonStatus;
  btnRadius?: ButtonRadiusSize;
}

const CustomButton = forwardRef<HTMLButtonElement, IButtonProps>((props, ref) => {
  const {
      btnType = ButtonType.DEFAULT,
      btnSize = ButtonSize.NORMAL,
      btnFont = ButtonFont.NORMAL,
      btnStatus,
      btnRadius,
      className,
      type = 'button', //  DEFAULT SAFETY
      ...restProps
    } = props;

  const classNames = cn(
    styles.customBtn,
    styles[btnType || ''],
    styles[btnSize || ''],
    styles[btnFont || ''],
    styles[btnStatus || ''],
    styles[btnRadius || ''],
    {
      [styles.disabled]: props.disabled,
    },
    className,
  );

  return (
    <button ref={ref} type={type} className={classNames} {...restProps}>
      {props.children}
    </button>
  );
});

export default CustomButton;
